export default function (config) {
    var l = (config.diameter / 2) + 'px';

    return {
        width:  l,
        height: l
    };
}